module.exports = __webpack_public_path__ + "img/8ad73f3c.1e68912c.jpeg";